module.exports = __webpack_public_path__ + "img/fixation_gray.7315ef46.png";